import { PrescriptionDetail } from "@/domain/entity/prescription/prescription-info-entity";
import { PrescriptionRepository } from "@/domain/repository/prescription-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchPrescriptionDetailUsecase {
  constructor(private readonly prescriptionRepo: PrescriptionRepository) {}

  async execute(
    patientUuid: string,
    prescriptionUuid: string,
  ): Promise<SATResult<PrescriptionDetail, SATError>> {
    return this.prescriptionRepo.fetchPrescriptionDetail(patientUuid, prescriptionUuid);
  }
}
